module.exports = __webpack_public_path__ + "media/images/admin/icons/video-efc11746ef749d844e0c8345173e8f43.svg";